module.exports = __webpack_public_path__ + "static/media/workInProgress.5a5a36bb.png";